import React from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";

import ButtonGhost from "../Button/ButtonGhost";
import ButtonSolid from "../Button/ButtonSolid";

const GenericTwoColumnSection = ({
  headingLevel,
  className,
  button,
  heading,
  subText,
  mainImage,
  desktopReversed,
}) => {
  const HeadingTag = headingLevel || "h2";

  return (
    <section className={`${className || "mb-20 md:mb-32 lg:mt-[87px]"}`}>
      <div className="container mx-auto max-w-[1267px]">
        <div className="flex flex-col-reverse items-center gap-y-8 md:grid md:grid-cols-2 md:gap-x-10 lg:gap-x-20">
          <div
            className={`order-2 w-full ${
              desktopReversed ? "md:order-2" : "md:order-1"
            }`}
          >
            <HeadingTag>{heading}</HeadingTag>
            {subText}

            <ButtonSolid
              altStyle={2}
              {...button}
              // href="/free-trial"
              // text="Start Free Trial"
            />
          </div>
          <div
            className={`order-1 flex items-center justify-center ${
              desktopReversed ? "md:order-1" : "md:order-2"
            } `}
          >
            {mainImage}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GenericTwoColumnSection;
